// Triangle Sweeper **固有**の設定（localStorage 永続）。
//
// 原作 iPad 版 `Classes/SettingModel.h` が持っていたのは
//   - `soundMute` / `playingBGM` … **ポータル横断**なので [settings.ts](@/platform/net/settings)（`hongsoft.*`）が既に持っている
//   - `fullVersion` … アプリ内課金。**移植しない**
//   - `gameModel` … 設定ではなくゲーム状態（中断再開の保存先）
// ＝ **このゲームに固有の「設定」は原作に存在しなかった**ので、長らく項目ゼロだった。
//
// 2026-08-06 に `claimedShapes`（**UnLock を押した形状**）が入った。設定というより
// 進捗寄りの値だが、ここへ載せるのは**サーバー無改修で端末をまたげる**ため
// （`games.*` の中身をサーバーは解釈しない＝D1 のスキーマ変更が要らない）。
// 中身と理由は [unlock.ts](unlock.ts) を参照。
//
// 項目を足すときは `read` / `apply` / `reset` の3か所を揃えること。
// キーは `triangle-sweeper.*` を使うこと（ポータル全体で1つの値なら `hongsoft.*`）。
import { GAME_KEY } from '@/games/triangle-sweeper/gameKey';
import type { GameSettingsSlice } from '@/platform/net/settings';
import {
  CLAIMED_SETTING_KEY,
  applyClaimed,
  readClaimed,
  resetClaimedShapes,
} from './unlock';

export const GAME_SETTINGS_DEFAULTS = { [CLAIMED_SETTING_KEY]: '' } as const;

/** このゲームの設定を既定値へ戻す（PREFERENCE の「初期設定に戻す」の一部）。 */
export function resetGameSettings(): void {
  resetClaimedShapes();
}

/**
 * サーバー同期用のスライス。[registry.ts](../../registry.ts) の `GAMES` に載っているので
 * `/api/settings` の `games['triangle-sweeper']` として自動で往復する。
 */
export const triangleSweeperSettingsSlice: GameSettingsSlice = {
  gameKey: GAME_KEY,
  read: () => ({ [CLAIMED_SETTING_KEY]: readClaimed() }),
  apply: (values) => {
    // 型が合わないものは無視して現状維持（スライスの取り決め）。
    const v = values[CLAIMED_SETTING_KEY];
    if (typeof v === 'string') applyClaimed(v);
  },
  reset: resetGameSettings,
};
